import { Input } from 'antd';
import styled from 'styled-components/macro';

export const StyledInputPass = styled(Input.Password)`
  min-height: 36px;
`;
